import { AxiosResponse } from "axios";
import Axios from "./axios";

class Settings {
    private axios: typeof Axios;

    constructor(axios: typeof Axios) {
        this.axios = axios;
    }

    get(): Promise<AxiosResponse> {
        return this.axios.get(`/settings`);
    }
}

export default new Settings(Axios);
